import { APP_NAME } from '@/constants/brand';

export const REMEMBER_ME_KEY = 'betiyan_admin_remember_me';
export const REMEMBERED_EMAIL_KEY = 'betiyan_admin_remembered_email';
export const APP_TITLE = import.meta.env.VITE_APP_NAME ?? `${APP_NAME} Admin`;
export const API_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:3001/api/v1';
